export const INIT = "INIT";
export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const ERROR = "ERROR";



// WEBPACK FOOTER //
// ./src/utils/helpers/phases.js